export default __webpack_public_path__ + "static/media/Wanja_neutral.893fef7d.jpg";